import React, {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { Avatar, Button, FormGroup } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import AccountCircle from '@material-ui/icons/AccountCircle';
import LockIcon from '@material-ui/icons/Lock';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { GoogleLogin } from 'react-google-login';
import { useHistory } from 'react-router-dom'
import { useSelector,useDispatch } from 'react-redux';
import { LinkedIn } from 'react-linkedin-login-oauth2';
import linkedin from 'react-linkedin-login-oauth2/assets/linkedin.png'
import { addProfile, setInterestsOpen, userSignIn } from '../../../redux/actions/index';
import { openSocketConnection } from '../../../socket';
import { fetchUserNotifications } from "../../../redux/dataFetchers/notificationApi";
import { fetchAllContent } from "../../../redux/dataFetchers/contentApi";
import Signup from './Signup';
import Forget from './Forget';
import '../Auth.css'
import Swal from 'sweetalert2';
import { FaLinkedin } from 'react-icons/fa';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width:'100vw',
    height:'100vh'
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: "7px",
  },
}));

export default function Sign({ btn }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const reduxState = useSelector(state => state)
  const [open, setOpen] = useState(false);
  const history = useHistory();
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // For hanlding the remember user.

  const [checked, setChecked] = useState(true);

  const handleCheck = (e) => {
    setChecked(e.target.checked);
  };

  const [state, setState] = useState({
    username: "",
    password: "",
  });

  const handleChange = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
  }

  const successResponseGoogle = (response) => {
    console.log(response)
    fetch('https://recruitingmonk-v2.azurewebsites.net/auth/google',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({tokenId:response.tokenId})
    }).then(res => res.json(res))
    .then(res => {
      console.log(res);
      if(res.success){
        localStorage.setItem("token", res.token);
        
        //assigning the new value to the state
        dispatch(userSignIn(res.token));
        dispatch(addProfile(res.user));
        openSocketConnection(dispatch);
        dispatch(fetchUserNotifications());
        if(res.interestsSelected)
          dispatch(fetchAllContent());
        else
          dispatch(setInterestsOpen(true));
      }
      handleClose();
    }).catch(error => {
      handleClose();
      console.log(error)
    })
  }

  const failureResponseGoogle = (response) => {
    console.log("Google login failed",response)
  }

  const successResponseLinkedin = (data) => {
    console.log(data.code)
    let code = data.code;
    fetch('https://recruitingmonk-v2.azurewebsites.net/auth/linkedin',{
      method:'POST',
      headers:{
        'Content-Type':'application/json'
      },
      body:JSON.stringify({code})
    }).then(res => res.json())
    .then(res => {
        console.log(res)
        if(res.success){
          localStorage.setItem("token", res.token);
          
          //assigning the new value to the state
          dispatch(userSignIn(res.token));
          dispatch(addProfile(res.user));
          openSocketConnection(dispatch)
          dispatch(fetchUserNotifications());
          if(res.interestsSelected)
            dispatch(fetchAllContent());
          else
            dispatch(setInterestsOpen(true));
        }
        handleClose();
    })
    .catch(err => {
        handleClose();
        console.log(err)
    })
  }

  const failureResponseLinkedin = (error) => {
    console.log(error)
  }

  const finalstep = (e) => {
    if (!state.username || !state.password) {
      handleClose();
      return Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter the Email or password! It Cannot be empty",
      });
    }

    var raw = JSON.stringify(state);

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    return fetch("https://recruitingmonk-v2.azurewebsites.net/login", requestOptions)
      .then((response) => {
        if (response.ok) {
          handleClose();
          return response;
        } else {
          handleClose();
          var error = new Error(
            "Error " + response.status + ": " + response.statusText
          );
          error.response = response;
          throw error;
        }
      },
        error => {
          var errmess = new Error(error.message);
          throw errmess;
        })
      .then(response => response.json())

      .then(result => {
        console.log(result)
        if(result.success){
          localStorage.setItem("token", result.token);
  
          //assigning the new value to the state
          dispatch(userSignIn(result.token));
          dispatch(addProfile(result.user));
          openSocketConnection(dispatch);
          dispatch(fetchUserNotifications());
          if(result.interestsSelected)
            dispatch(fetchAllContent());
          else
            dispatch(setInterestsOpen(true));
          console.log(reduxState.info.info)
        }
      })
      .catch((error) => {
        console.log("Error", error);
        if (error?.response?.status < 500)
          return Swal.fire({
            icon: "error",
            title: "Wrong Credentials",
            text: "Please enter correct email or password",
          });

        if (error?.response?.status >= 500)
          return Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Internal server error!",
          });
      });
  };

  return (
    <div className="Sign" id="signin">
      {reduxState.authUser.isAuthenticated? (
        reduxState.info.info.avatar?
        <Avatar alt="profile icon" src={reduxState.info.info.avatar} onClick={()=>history.push('/profile')} className="avatar cursor-default" /> :
        <AccountCircle style={{color:"#b32800",fontSize:'2.5rem',marginLeft:'0.7rem',cursor:'pointer',marginLeft:'0.8rem'}} onClick={()=>history.push('/profile')} />
      ) : (
        <div
          className="flex flex-row items-center justify-between"
        >
          <Signup btn={btn} />
          <Button
            className=""
            variant={btn ? "contained" : "text"}
            style={{
              color: btn ? "#fff" : "#B0343C",
              backgroundColor: btn ? "#B0343C" : "#fff",
              fontWeight: "bold",
            }}
            type="button"
            onClick={handleOpen}
          >
            Sign in
          </Button>
        </div>
      )}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade
          in={open}
          className="signinModal glass-6 flex flex-col items-center p-4 w-5/6 md:w-1/4"
          id="siginModalId"
        >
          <div className="px-6" style={{
              backgroundColor: "#eccdb2",
              borderRadius: "5px",
            }}>
            <div
              className="flex flex-col items-center gap-4 w-full"
              id="transition-modal-title"
            >
              <GoogleLogin
              clientId="184778796786-pd8mft6j3nkk5a2mnb78r8jjem2ot0q5.apps.googleusercontent.com"
              buttonText="Sign in with Google"
              onSuccess={successResponseGoogle}
              onFailure={failureResponseGoogle}
              cookiePolicy={'single_host_origin'}
              className="google_btn"
            />
              <div style={{width:'100%'}}>
                <LinkedIn
                  clientId="78q6ffsfov0zok"
                  scope="r_liteprofile r_emailaddress"
                  onFailure={failureResponseLinkedin}
                  onSuccess={successResponseLinkedin}
                  redirectUri="https://recruitingmonk-app.azurewebsites.net/linkedin"
                  renderElement={({ onClick, disabled }) => (
                  <button onClick={onClick} disabled={disabled} style={{padding:'0px',border:'none',width:'100%'}}>
                    <Button id="transition-modal-description" variant="contained" style={{backgroundColor:'#0274b3',color:'#fff',width:'100%',margin:'0px',textTransform:'capitalize'}} startIcon={<FaLinkedin />}>Sign in with <p style={{ fontWeight: 'bold' }}>&nbsp;LinkedIn</p></Button>
                  </button>
                  )}
                >
                <img src={linkedin} alt="Log in with Linked In" style={{ maxWidth: '180px' }} />
                </LinkedIn>
              </div>
            </div>

            <div class="my-2">or use</div>

            <div className="flex flex-col items-center w-full">
              <div className="flex flex-row items-center w-full my-2">
                <AccountCircle className="text-white self-end mr-3" />
                <TextField
                  id="input-with-icon-grid"
                  label="Email"
                  name="username"
                  value={state.username}
                  fullWidth
                  onChange={handleChange}
                  type="email"
                  required
                />
              </div>
              <div className="flex flex-row items-center w-full my-2">
                <LockIcon className="text-white self-end mr-3" />
                <TextField
                  id="input-with-icon-grid"
                  label="Password"
                  name="password"
                  fullWidth
                  value={state.password}
                  onChange={handleChange}
                  type="password"
                  required
                />
              </div>
            </div>

            <div className="flex flex-row items-center w-full justify-between">
              <FormGroup style={{ fontSize: "10px" }}>
                <FormControlLabel
                  className="addtnlLogTool"
                  control={
                    <Checkbox
                      checked={checked}
                      onChange={handleCheck}
                      name="checkedMe"
                      style={{ color: "#767676", fontSize: "10px" }}
                      size="small"
                    />
                  }
                  label="Remember Me!"
                />
              </FormGroup>

              <p style={{ color: "#B0343C", cursor: "pointer" }}>
                <Forget signModalOpen={setOpen} />
              </p>
            </div>
            <Button
              variant="contained"
              container
              fullWidth
              style={{ backgroundColor: "#B0343C", color: "#fff" }}
              onClick={finalstep}
            >
              Login
            </Button>
            <div className="flex flex-row items-center mt-4">
              <p>Don't have account, </p>
              <p className="ml-3">
                <Signup />
              </p>
            </div>
          </div>
      </Fade>
    </Modal>
  </div>
  );
}
